import React from "react";
import { PharmacyRegisterView } from "../components/RegisterView";
import { useTranslation } from 'react-i18next';


const RegisterNewPharmacyPage = () => {

  const { t } = useTranslation();
  
  return (
    <div>
      <h1>{t('register_pharmacy.topic')}</h1>
      <div className="half-panel">
        <PharmacyRegisterView />
      </div>
    </div>
  )
}

export default RegisterNewPharmacyPage;
